
  import { defineComponent } from "@nuxtjs/composition-api";

  export default defineComponent({
    props: {
      onSeason: Boolean,
      partnerLogoRendered: Boolean
    }
  });
